import React from 'react'

const ToolbarButton = ({ active, onClick, children }) => (
  <div className={`toolbar-btn ${active ? 'active' : ''}`} onClick={onClick}>
    { children }
  </div>
)
export default ToolbarButton
